/**
 * Contains language related methods.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class LanguageUtility {
  /**
   * Current language ID.
   *
   * @type {number}
   * @private
   */
  private static _id: number;

  /**
   * Language labels.
   *
   * @type { [key: string]: string }
   * @private
   */
  private static _labels: { [key: string]: string };


  /**
   * Gets the current language ID.
   *
   * @returns {number}
   */
  static get id(): number {
    if (this._id === undefined) {
      if (Globals.languageId === undefined) {
        throw new Error('Variable "Globals.languageId" is missing.');
      }
      this._id = parseInt(Globals.languageId);
    }

    return this._id;
  }


  /**
   * Gets the language labels.
   *
   * @returns { [key: string]: string }
   */
  static get labels(): { [key: string]: string } {
    if (this._labels === undefined) {
      if (Globals.labels === undefined) {
        throw new Error('Variable "Globals.labels" is missing.');
      }
      this._labels = Globals.labels;
    }

    return this._labels;
  }


  /**
   * Gets a language label.
   *
   * @param {string} key Key of the label to get
   * @returns {string}
   */
  static getLabel(key: string): string {
    if (this.labels.hasOwnProperty(key)) {
      return this.labels[key];
    }
    return '';
  }
}
